import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import StringHelper from '../../lib/StringHelper';
import AjaxBase from '../../../../lib/AjaxBase';
import { Table, Spin, Collapse,Checkbox,Button,message,Modal,Input } from "antd";
import moment from 'moment';
const Panel = Collapse.Panel;
const CheckboxGroup = Checkbox.Group;


export default class DevelopmentReportDetailPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      classId: props.params.classId ? props.params.classId : 0,
      studentId: props.location.query.studentId ? props.location.query.studentId : 0,
      gradeId: props.location.query.gradeId ? props.location.query.gradeId : 0,
      name: props.location.query.name ? props.location.query.name : '',
      categories: [],
      columns: [],
      loading: false,
      activeKey: [],
      semester: props.location.query.semester ? props.location.query.semester : SharedTools.getCurrentSemester(),
      hasCategory:false,
      downloadLoading:false,
      before:true,
      after:true,
      archivePdfModal:false,
      submitLoading:false,
    };
    // bind this
    this.changeActiveKey = this.changeActiveKey.bind(this)
    this.changeLevel = this.changeLevel.bind(this)
    this.onDownloadPdf = this.onDownloadPdf.bind(this)
    this.showArchivePdfModal = this.showArchivePdfModal.bind(this)
  }

  componentDidMount() {
    let { studentId, gradeId, classId, semester} = this.state;
    let data = {
      class_grade_id: gradeId,
      semester
    }
    DataService.getEvaluationCategories(data).then((res) => {
      this.setState({
        categories: res,
        hasCategory:true,
        activeKey: [String(res[0].id)]
      })

      if (res.length > 0) {
        this.getDevelopmentReport(res[0].id)
      }
    }).catch((error) => {
      console.log(error);
      this.setState({
        hasCategory:false,
        loading: false
      })
    });
    
  }
  changeLevel(e) {
    if(e.target.value=='before'){
      this.setState({
        before:e.target.checked
      })
    }
    if(e.target.value=='after'){
      this.setState({
        after:e.target.checked
      })
    }

  }
  onDownloadPdf(){
    let status = this.checkEmail(this.state.email);
    if(status){
      let { studentId, gradeId, classId, semester,before,after } = this.state;
      let data = {
        class_grade_id:gradeId,
        class_record_id:classId,
        semester,
        before,
        after,
        student_id:studentId?studentId:null,
        mail_address: this.state.email,
      }
      if(!this.state.hasCategory){
        message.error("未创建评价体系，请先创建！")
        this.setState({
          loading:false
        })
        return
      }
      this.setState({
        submitLoading:true,
      })
      DataService.sendDevelopmentReportToArchiveMail(data).then((res) => {
        this.setState({
          submitLoading:false,
        })
        Modal.success({
          title: '发展报告制作中',
          content: `${this.state.name}的发展报告将会在5个工作日内发送到您${this.state.email}的邮箱，请注意查收。`,
        });
        this.setState({
          email: '',
          archivePdfModal: false
        })
      }).catch((error) => {
        console.log(error)
        this.setState({
          submitLoading:false,
        })
        this.setState({
          email: '',
          archiveBookModal: false
        })
      });
      // if(!studentId){
      //   window.open(AjaxBase.URL_PREFIX + `evaluations/get_class_pdf?class_record_id=${classId}&class_grade_id=${gradeId}&semester=${semester}&before=${before}&after=${after}`)
      // }
      // else{
      //   window.open(AjaxBase.URL_PREFIX + `evaluations/get_student_pdf?student_id=${studentId}&semester=${semester}`)
      // }
    }
  }

  checkEmail(email) {
    var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
    if (email === "") { //输入不能为空
      message.error('填写的邮箱不能为空')
      return false;
    } else if (!reg.test(email)) { //正则验证不通过，格式不对
      message.error('邮箱格式错误，请重新填写')
      return false;
    } else {
      return true;
    }
  }
  
  showArchivePdfModal(){
    this.setState({archivePdfModal:true})
  }
  _renderArchivePdfModal() {

    return <Modal
      className="archive-book-modal"
      footer={[<Button key="back" loading={this.state.submitLoading} onClick={this.onDownloadPdf.bind(this)} type="primary">提交</Button>]}
      title="获取发展报告"
      onCancel={() => { this.setState({ archivePdfModal: false})}}
      visible={this.state.archivePdfModal}
      maskClosable={false}
    >
      <div className="edit-name">
        <Input addonBefore={<span><span className="red">*</span>邮箱</span>} value={this.state.email} onChange={(e) => this.setState({email: e.target.value})} data-type="name" />
        <p>我们将在5个工作日内将{this.state.name}的发展报告发送至您的邮箱</p>
      </div>
    </Modal>
  }
  getDevelopmentReport(category_id) {
    this.setState({
      loading: true
    })
    let { studentId, gradeId, classId, categories, semester } = this.state;
    let formData = {
      category_id,
      class_grade_id: gradeId,
      semester
    }
    studentId ? formData.student_id = studentId : formData.class_record_id = classId

    if(studentId){
      DataService.getDevelopmentReport(formData).then((res) => {
        this.toolColumns(res.evaluation_levels)
        let item = categories.find(c => c.id == category_id)
        item.child_categories = res.data
        item.get_status = true
  
        this.setState({
          categories,
          loading: false
        })
      }).catch((error) => {
        console.log(error);
        this.setState({
          loading: false
        })
      });
    }
    else{
      DataService.getClassReport(formData).then((res) => {
        this.toolColumns(res.evaluation_levels)
        let item = categories.find(c => c.id == category_id)
        item.child_categories = res.data
        item.get_status = true
  
        this.setState({
          categories,
          loading: false
        })
      }).catch((error) => {
        console.log(error);
        this.setState({
          loading: false
        })
      });
    }

  }

  changeActiveKey(key) {
    let oldKey = this.state.activeKey;
    let ids = key.filter(item => !oldKey.includes(item))
    if (ids && ids.length > 0) {
      let item = this.state.categories.find(c => c.id == ids[0])
      if (!item.get_status) {
        this.getDevelopmentReport(ids[0])
      }
    }
    this.setState({
      activeKey: key
    })
  }

  toolColumns(levels) {
    let columns = [{
      title: '评价类别',
      className: 'row',
      dataIndex: 'title',
      key: 'title',
      width: 180,
      render: text => <span>{text}</span>,
    }];
    levels.forEach(level => {
      let item = {
        title: `${level.title}`,
        className: 'row',
        dataIndex: `level_${level.level}`,
        key: `level_${level.level}`,
        width: 100,
        render: (text, record) => 
          this.state.studentId?
            <div>
            <span>
              {text && text.length > 0 && text.map(s => <div key={s.id + '-' + s.student_id + '-' + s.record_at}>{this.state.studentId ? this.toolDate(s.record_at) : s.student_name}</div>)}
            </span>
          </div>
          :<div style={{ display: "flex" ,justifyContent: "center" }}>
          <span style={{ marginRight: "10px" }}>
            {text && text.student_before.length > 0 &&this.state.before&& text.student_before.map((s,index) => <div style={{"color": "blue"}} key={`${text.evaluation_levels}`+'-'+`${index}`}>{this.state.studentId ? s : s}</div>)}
          </span>
          <span >
          {text && text.student_after.length > 0 &&this.state.after&& text.student_after.map((s,index) => <div style={{"color": "green"}} key={`${text.evaluation_levels}`+'-'+`${index}`}>{this.state.studentId ? s : s}</div>)}        
                        </span>
          </div>     
                        
      }
      columns.push(item)
    });
    this.setState({
      columns
    })
  }

  toolDate(date) {
    return date ? moment(date).format('YYYY.MM.DD') : date
  }

  render() {
    let { columns, categories, name, studentId, loading } = this.state;

    return (
      <div className="development-report-detail-page">
        <div className="page-header">
          <div className="class-label">{studentId ? '姓名' : '班级'}</div>
          <div className="class-name">{name}</div>
          {!studentId?
          <div className="change-label">
            <Checkbox value="before" onChange={this.changeLevel} checked={this.state.before}>期初评价</Checkbox>
            <Checkbox value="after"onChange={this.changeLevel} checked={this.state.after}>期末评价</Checkbox>
          </div>:''}
          <Button style={{ marginLeft: "10px" }} type="primary" onClick={this.showArchivePdfModal} loading={this.state.downloadLoading}>获取发展报告</Button>
        </div>
        {this.state.hasCategory?<Collapse activeKey={this.state.activeKey} onChange={this.changeActiveKey}>
          {categories.map(item =>
            <Panel header={item.title} key={item.id}>
              <Spin spinning={loading}>
                  <Table columns={columns}
                    dataSource={item.child_categories}
                    pagination={false}
                    bordered={true}
                    className="report-table"
                    rowKey={record => record.id}
                    scroll={{ x: '100%' }}
                  />
              </Spin>
            </Panel>)}
        </Collapse>:<span className='without-categories'style={{ display: "flex" ,justifyContent: "center" }}>未创建评价体系</span>}
        {this._renderArchivePdfModal()}
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/DevelopmentReportDetailPage.jsx